module.exports = "<p>\n  land-rec-details works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/land-rec-details/land-rec-details.component.html
// module id = ./src/app/landprocurement/land-rec-details/land-rec-details.component.html
// module chunks = main